import React from 'react';

const AuthContext = React.createContext({
    isAuthenticated: false
})

export default AuthContext;